import { Modal } from "antd";
import { showAppModal } from "~/redux/actions/app";
import { isWechatBrowser } from "~/utils/wechat";

/**
 * 电量不足提示组件
 */
const EleInsufficientContent = ({ balance, cost }) => (
  <div>
    <p>
      哎呀，您的电量不足啦！剩余电量{" "}
      <span className="text-primary">{balance}</span>，本次需要消耗{" "}
      <span className="text-primary">{cost}</span> 电量。
      可付费充电，支持社区发展哦：）
    </p>
    <p>
      <a
        href="https://eleduck.com/posts/6GzfGe"
        className="text-primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        电量的作用及如何获取电量？
      </a>
    </p>
  </div>
);

/**
 * 处理电量不足的情况
 *
 * @param {object} options 配置选项
 * @param {number} options.balance 当前电量余额
 * @param {number} options.cost 需要消耗的电量
 * @param {function} options.dispatch Redux dispatch 函数
 * @param {object} options.router Next.js router 对象
 * @returns {void}
 */
export const handleInsufficientEle = ({ balance, cost, dispatch, router }) => {
  const handleChargeRequest = () => {
    if (isWechatBrowser()) {
      router.push("/profile/info");
    } else {
      dispatch(showAppModal("TopUpModal"));
    }
  };

  Modal.confirm({
    title: "电量余额不足",
    okText: "去充电",
    closable: true,
    content: (
      <EleInsufficientContent
        balance={balance}
        cost={cost}
      />
    ),
    onOk: handleChargeRequest,
  });
};
